"use client";

import { cn } from "@/src/shared/utils/mergeTwClasses";
import { useTextUsModalStore } from "@/src/stores/useTextUsModalStore";
import { IconButton } from "@mui/material";
import { FC } from "react";
import { Button } from "../../Button";
import WebshopIcon from "../../WebShopIcon/components/WebShopIcon";
import { LetterActionProps } from "../lib/type";
import {useAnalytics} from "@/src/components/pages/StepPage/components/useAnalytics";

export const LetterAction: FC<LetterActionProps> = ({ name, variant, icon, analytics }) => {
    const { callAnalyticEvent } = useAnalytics();
    const openTextUsModal = useTextUsModalStore((state) => state.open);

    return (
        <>
            <Button
                variant={variant}
                className={cn("min-w-[132px] text-xs max-md:hidden")}
                size={"small"}
                startIcon={<WebshopIcon name={icon.name} width={16} height={16} />}
                onClick={() => {
                    openTextUsModal();
                    analytics && callAnalyticEvent(analytics);
                }}
            >
                {name}
            </Button>
            <IconButton
                className={cn("hidden max-md:flex")}
                onClick={() => {
                    openTextUsModal();
                    analytics && callAnalyticEvent(analytics);
                }}
                aria-label={name + " letter"}
            >
                <WebshopIcon
                    name={icon.name}
                    fill={icon.color ?? undefined}
                    width={26}
                    height={26}
                />
            </IconButton>
        </>
    );
};
